/* eslint-disable react/jsx-filename-extension */
import React,{useState,useEffect} from "react";
import { Switch, Row, Col, Collapse, Form, Checkbox } from "antd";

const { Panel } = Collapse;
const RoleIndexPermission = ({ updateInitialValue, selectHmg ,getFieldValue, setFieldsValue }) => {

  const [indexAccess, setIndexAccess] = useState(false)

  useEffect(() => {
    setIndexAccess(getFieldValue('index_permission_access'))
  }, [getFieldValue('index_permission_access')])
  const projectPermissionInitialValue = (hmgId, indexId) => {
    let initialValue = false;
    const indexPermission = updateInitialValue?.role_data?.index_permissions?.index_permission_access
    if (!indexPermission) {
      initialValue = true;
    } else if (
      updateInitialValue?.role_data?.index_permissions?.permission_list?.find(
        (e) => e.hmg_id === hmgId && e.index_id === indexId && e.value
      )
    ) {
      initialValue = true;
    }
    return initialValue;
  };

  const indexPermissionOnChange= (value) =>{
    setIndexAccess(prevState => !prevState)
    setFieldsValue({index_permission_access:value})

    const fields = getFieldValue('index_permission_list')
    Object.keys(fields).forEach(hmg => {
      Object.keys(fields[hmg]).forEach(indexId => {
        fields[hmg][indexId] = true;
      });
    });
  };
  return (
    <Collapse defaultActiveKey={["index_permissions_1"]} expandIconPosition="end">
      <Panel header="Index Permissions" key="index_permissions_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Index Permissions</label>
              </Col>

              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  name="index_permission_access"
                  valuePropName="checked"
                  style={{
                    borderBottom: "none",
                  }}
                  initialValue={
                    updateInitialValue?.role_data?.index_permissions?.index_permission_access
                      ? true
                      : false
                  }
                >
                  <Switch onChange={indexPermissionOnChange}/>
                </Form.Item>
              </Col>
            </Row>
          </div>

          {selectHmg.map((d) => (
            <div className="is_form_2_aa" key={d.primary_hmg_id}>
              <Row>
                <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                  <label>
                    {d.hmg_name} - {d.project_name}
                  </label>
                </Col>

                <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                  <Row>
                    {Array.isArray(d.indexes)
                      ? d.indexes.map((b) => (
                          <Col
                            xxl={3}
                            xl={6}
                            lg={6}
                            sm={8}
                            key={b.index_id._id}
                          >
                            <Form.Item
                              name={[`index_permission_list`,d.primary_hmg_id,b.index_id._id]}
                              valuePropName="checked"
                              initialValue={projectPermissionInitialValue(
                                d.primary_hmg_id,
                                b.index_id._id
                              )}
                              style={{
                                borderBottom: "none",
                              }}
                            >
                              <Checkbox disabled={!indexAccess}>{b.index_id.name}</Checkbox>
                            </Form.Item>
                          </Col>
                        ))
                      : null}
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </Panel>
    </Collapse>
  );
};

export default RoleIndexPermission;
